<template>
	<div>
		<div class="content">
			<div v-if="loading">
				<bouncing-component></bouncing-component>
			</div>
			<div v-else>
				<div v-if="histories.length">
					<success-component
							v-if="success.length > 0"
							:message="success">
					</success-component>
					<error-component
							v-if="exceptions.length > 0"
							v-bind="exceptions[0]">
					</error-component>

					<b-list-group columns class="row d-flex align-items-stretch">
						<b-list-group-item v-for="(query, index) in histories"
								:key="query.id" class="ml-2">
							<div class="pull-left">
								<h5 class="card-title pull-left">{{ query.query }}</h5>
								<div class="clearfix">Last Update: {{ query.updated_at }}</div>
							</div>
							<b-button-group class="pull-right">
								<b-button variant="primary" @click="edit(query.query)" v-b-tooltip.hover title="Use this query">
									<font-awesome-icon icon="edit" />
								</b-button>
								<b-button variant="danger"
										v-b-tooltip.hover title="Delete"
										@click="del(query.id, index)">
									<font-awesome-icon icon="trash-alt" />
								</b-button>
							</b-button-group>
						</b-list-group-item>
					</b-list-group>

					<b-pagination  align="center" size="md"
						:total-rows="pagination.totalRows"
						v-model="pagination.currentPage"
						:limit="pagination.limit"
						:per-page="pagination.limit"
						@change="change"
						class="mt-4">
					</b-pagination>
				</div>
				<span v-else> <strong>You don't have any history yet</strong></span>
			</div>
		</div>
	</div>
</template>

<script>
	import { mapState } from 'vuex';

	import ErrorComponent from '../../components/ErrorView.vue';
	import SuccessComponent from '../../components/Success.vue';
	import BouncingComponent from '../../components/Bouncing-loader.vue';

	export default {
		props: ['query_id'],
		data() {
			return {
				unwatch: '',
				loading: true
			}
		},
		methods: {
			change(page) {
				this.pagination.currentPage = page;
				this.$store.dispatch('queries/fetchHistories', this.query_id);
			},
			edit(query) {
				this.$store.commit('queries/SET_HISTORY_FLAG', true);
				this.$store.commit('queries/SET_HISTORY_DATA', query);
				this.$store.commit('queries/SET_RESULTS', []);
				this.$store.commit('queries/SET_CURRENT_COMPONENT', 'query-create');
			},
			del(id, index) {
				this.$swal({
					title: 'Be careful',
					text: "Are you sure?",
					type: 'warning',
					width: '350px',
					showCancelButton: true,
					confirmButtonColor: '#3085d6',
					confirmButtonText: 'Confirm'
				}).then((result) => {
					if (result.value) {
						let payload = {
							id: id,
							index: index
						};
						this.$store.dispatch('queries/deleteHistory', payload);
					}
				})
			}
		},
		computed: {
			...mapState('queries', {
				histories: 'histories',
				query: 'query',
				pagination: 'pagination',
			}),
			...mapState({
				success: 'success',
				exceptions: 'exceptions'
			})

		},
		beforeDestroy() {
			this.$store.dispatch('clearMessages');
			this.unwatch();
		},
		created() {
			this.$store.commit('queries/SET_CONNECTION_SELECTED', -1);
			this.loading = true;
			this.$store.dispatch('queries/fetchHistories', this.query_id).finally(() => {
				this.loading = false;
			});
			this.unwatch = this.$store.watch(
				(state)=>
					this.$store.state.organizationSelected
				,
				(newValue, oldValue)=>{
					this.$store.dispatch('queries/setInitialStatus');
					this.$store.dispatch('clearMessages');
					this.$router.replace({ name: 'query.create' });
				},
			);
			
		},
		components: {
			ErrorComponent,
			SuccessComponent,
			BouncingComponent
		}
	}
</script>

<style scoped>
	.nav-tabs .nav-link.active, .nav-tabs .nav-item.show .nav-link {
		background-color: #ffffff;
		border-bottom: solid 1px #ffffff;
	}
</style>